import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../shared/appSettings';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
//import { Router } from '@angular/router';

import * as moment from "moment";
import { IUserLogin, IUser, IUserSearch } from "./user";

@Injectable()
export class AuthService {
     
    private _authUrl = this._appSettings.API_ENDPOINT + 'user';
    
    constructor(private _http: HttpClient, private _appSettings: AppSettings) {

    }

    login(user: IUserLogin): Observable<IUserLogin[]> {
        return this._http.post(this._authUrl + "/signin", user)
            .do(data => { this.setSession(data); console.log('All: ' +  JSON.stringify(data)) })
            .catch(this.handleError);
    }

    getRoles(): Observable<string[]> {
        return this._http.get(this._authUrl + "/admin/role")
            .do(data => console.log('All: ' +  JSON.stringify(data)))
            .catch(this.handleError);
    }

    getUser(id: string): Observable<IUser> {
        return this._http.get(this._authUrl + "/admin/" + id)
            .do(data => console.log('All: ' +  JSON.stringify(data)))
            .catch(this.handleError);
    }

    getUsers(): Observable<IUser[]> {
        return this._http.get(this._authUrl + "/admin")
            .do(data => console.log('All: ' +  JSON.stringify(data)))
            .catch(this.handleError);
    }

    getUsersByFilters(search: IUserSearch): Observable<any> {
        return this._http.post(this._authUrl+ '/admin/search', search)
            .do(data => console.log('All: ' +  JSON.stringify(data)))
            .catch(this.handleError);
    }

    saveUser(user: IUser): Observable<IUser[]> {
        return this._http.post(this._authUrl + "/admin", user)
            .do(data => console.log('All: ' +  JSON.stringify(data)))
            .catch(this.handleError);
    }

    updateUser(user: IUser): Observable<IUser[]> {
        return this._http.put(this._authUrl + "/admin/" + user._id, user)
            .do(data => console.log('All: ' +  JSON.stringify(data)))
            .catch(this.handleError);
    }

    deleteUser(id: string): Observable<IUser[]> {
        return this._http.delete(this._authUrl + "/admin/" + id)
            .do(data => console.log('All: ' +  JSON.stringify(data)))
            .catch(this.handleError);
    }

    private setSession(authResult) {
        const expiresAt = moment().add(authResult.expiresIn,'second');

        localStorage.setItem('id_token', authResult.token);
        localStorage.setItem("expires_at", JSON.stringify(expiresAt.valueOf()) );
    }          

    logout() {
        localStorage.removeItem("id_token");
        localStorage.removeItem("expires_at");
    }

    public getToken() {
        return localStorage.removeItem("id_token");
    }

    public redirectLogin() {
        //this.router.navigateByUrl('/login');
    }

    public isLoggedIn() {
        return moment().isBefore(this.getExpiration());
    }

    isLoggedOut() {
        return !this.isLoggedIn();
    }

    getExpiration() {
        const expiration = localStorage.getItem("expires_at");
        const expiresAt = JSON.parse(expiration);
        return moment(expiresAt);
    }   
    
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        if (error.status == 401) {
            return Observable.throw(error["error"] || 'Server error');
        }
        return Observable.throw(error.json() || 'Server error');
    }
}




// WEBPACK FOOTER //
// ./src/app/routes/auth/auth.service.ts